import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/fold-out-animation.css';

import React, { Fragment } from 'react';
import AwesomeSlider from 'react-awesome-slider';

import { inject } from 'mobx-react';

@inject('artistStore')
export default class Bio
extends React.Component {
	render () {
		const { artistStore, match: { params: { id } } } = this.props;

		if (artistStore.isLoading) {

			return (<h1>Loading...</h1>);
		}
		
		const artist = artistStore.getItemByID(id);
		const { name, bio } = artist;

		return (
			<Fragment>
				<div className="row expanded align-justify margin-0">
					<div className="column large-6">
						<div className="section-title margin-bottom-2" style={{paddingLeft: '0'}}>{ name }</div>
						<div style={{fontFamily: 'NTR', fontSize: '1.2rem'}} dangerouslySetInnerHTML={{ __html: bio }} />
					</div>
					{/* <div className="column large-6">
						<AwesomeSlider
							infinite={true}
							className="mzd-awesome-slider"
							organicArrows={true}
							bullets={true}
							animation="foldOutAnimation"
						>
							<div data-src='https://townsquare.media/site/959/files/2020/05/GettyImages-531718428.jpg?w=980&q=75'/>
							<div data-src='https://www.biography.com/.image/t_share/MTIwNjA4NjMzNDczNzYyODI4/95-106-capital-fm-summertime-ball-2012---media-run.jpg'/>
							<div data-src='https://blog.siriusxm.com/wp-content/uploads/2016/08/usher_marohagopian_3844_cropped-e1591908392509.jpg?w=450'/>
						</AwesomeSlider>
					</div> */}
				</div>
			</Fragment>
		);
	}
}
